import { Product } from '../types/product';
import { Brand } from '../types/brand';

/**
 * Enhances products with brand names using cached brand data
 * This eliminates the need to make separate API calls for each product's brand
 */
export const enhanceProductsWithBrands = (
  products: Product[], 
  brands: Brand[]
): Product[] => {
  return products.map(product => {
    if (product.brandId && !product.brand) {
      const brand = brands.find(b => b.id === product.brandId);
      return {
        ...product,
        brand: brand?.name || 'Unknown Brand'
      };
    }
    return product;
  });
};

/**
 * Gets brand name by brandId from cached brands
 */
export const getBrandNameById = (brandId: number, brands: Brand[]): string | undefined => {
  return brands.find(b => b.id === brandId)?.name;
};

/**
 * Gets full brand object by brandId from cached brands
 */
export const getBrandById = (brandId: number, brands: Brand[]): Brand | undefined => {
  return brands.find(b => b.id === brandId);
};
